import React from "react";
import { bool, object, func, string } from "prop-types";
import { Row, Col, Button } from "react-bootstrap";
import scoreRangeIcon from "resources/images/criteria-score-range-icon.svg";

const JobScoreRange = ({
  job,
  jobDetailId,
  fromCandidateProfile,
  setShowCopyCandidateConfirmationModal,
  setSelectedJobToCopyCandidate,
  candidateFirstName,
  moveEmailCandidatesPermission,
}) => {
  const jobTitle = job && job.get("jobTitle");
  const jobCode = job && job.get("jobCode");

  const scoreRangeTypeText =
    job &&
    job.get("scoreRanges") &&
    job.get("scoreRanges").valueSeq().first() &&
    job.get("scoreRanges").valueSeq().first().get("isDefault")
      ? "Criteria"
      : "Custom";

  const scoreRangeData =
    job &&
    job.get("scoreRanges") &&
    job
      .get("scoreRanges")
      .entrySeq()
      .map(([id, scoreRange]) => {
        const scoreRangeName = scoreRange.get("scoreRangeName");
        const scoreRangeMin = scoreRange.get("rangeLow").split(".")[0];
        const scoreRangeMax = scoreRange.get("rangeHigh").split(".")[0];

        return (
          <div
            key={id}
          >{`${scoreRangeName} (${scoreRangeMin} - ${scoreRangeMax})`}</div>
        );
      });

  const handleShowCopyCandidateModal = () => {
    const updatedJob = job.setIn(["jobDetailId"], jobDetailId);

    setSelectedJobToCopyCandidate(updatedJob);
    setShowCopyCandidateConfirmationModal(true);
  };

  const showCopyCandidate =
    fromCandidateProfile && moveEmailCandidatesPermission;

  return (
    <Row className="talent-mobility-score-range-container mr-0">
      <Col className="px-0">
        <Row className="mr-0">
          <Col style={{ paddingLeft: "26px" }}>
            <div className="mb-1" style={{ color: "#53565a" }}>
              EPP Score Range for
            </div>
            <div
              className="mb-1"
              style={{ fontSize: "16px", color: "#001f4e", fontWeight: "bold" }}
            >
              {jobTitle}
            </div>
            {fromCandidateProfile && (
              <div style={{ color: "#53565a" }}>{jobCode}</div>
            )}
          </Col>
          {showCopyCandidate && (
            <Col className="d-flex justify-content-end align-items-center pr-0">
              <Button
                onClick={handleShowCopyCandidateModal}
                variant="outline-primary"
                id="showCopyCandidateConfirmationModalBtn"
                style={{ backgroundColor: "#fff", fontWeight: "bold" }}
              >
                Copy {candidateFirstName} to this Job
              </Button>
            </Col>
          )}
        </Row>
        <hr style={{ margin: "18px 0px" }} />
        <Row>
          <Col className="d-flex align-items-center pl-3">
            <img
              src={scoreRangeIcon}
              alt="criteria score range"
              height="40px"
              width="40px"
            />
            <div
              className="ml-3"
              style={{ color: "#02215a", fontSize: "14px" }}
            >
              <div style={{ fontWeight: "bold" }}>
                {scoreRangeTypeText} Score Range:
              </div>
              {scoreRangeData}
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

JobScoreRange.propTypes = {
  job: object,
  jobDetailId: string,
  fromCandidateProfile: bool,
  setShowCopyCandidateConfirmationModal: func,
  setSelectedJobToCopyCandidate: func,
  candidateFirstName: string,
  moveEmailCandidatesPermission: bool,
};

export default JobScoreRange;
